import { fetchToken } from "../../common/FetchCookie";
import { ADMIN, BASE_URL, INTERVIEW_PREPARATION, CAREER_ADVICE_ADMIN } from "../../common/URLs";

// Helper: throw on non-OK or { status: false }
const parseJsonOrThrow = async (res) => {
    // Safely parse even when server returns empty or non-JSON body (500 HTML, etc.)
    const text = await res.text();
    let json = {};
    try {
        json = text ? JSON.parse(text) : {};
    } catch {
        json = {};
    }

    if (!res.ok || json?.status === false) {
        const message = json?.message || json?.error || `Request failed (${res.status})`;
        const err = new Error(message);
        err.response = json;
        err.status = res.status;
        throw err;
    }
    return json;
};

export const fetchCareerAdviceAdmin = async () => {
    const token = await fetchToken();
    const res = await fetch(`${BASE_URL}/${ADMIN}/${CAREER_ADVICE_ADMIN}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
        },
    });
    return parseJsonOrThrow(res); // { status, response: [...], code }
};

export const addCareerAdviceAdmin = async (newItem) => {
    const token = await fetchToken();
    const isFormData = typeof FormData !== "undefined" && newItem instanceof FormData;

    const headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    if (!isFormData) {
        headers["Content-type"] = "application/json";
    }

    const res = await fetch(`${BASE_URL}/${ADMIN}/${CAREER_ADVICE_ADMIN}`, {
        method: "POST",
        headers,
        body: isFormData ? newItem : JSON.stringify(newItem),
    });
    return parseJsonOrThrow(res); // { status, response: {...}, code }
};

// UPDATED: supports JSON or FormData. For FormData, use POST + _method=PUT (Laravel-friendly)
export const updateCareerAdviceAdmin = async (uuid, updated) => {
    const token = await fetchToken();
    const isFormData = typeof FormData !== "undefined" && updated instanceof FormData;

    const headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    let method = "PUT";
    let body = updated;

    if (isFormData) {
        updated.append("_method", "PUT");
        method = "POST"; // override with _method
    } else {
        headers["Content-type"] = "application/json";
        body = JSON.stringify(updated);
    }

    const res = await fetch(`${BASE_URL}/${ADMIN}/${CAREER_ADVICE_ADMIN}/${uuid}`, {
        method,
        headers,
        body,
    });
    return parseJsonOrThrow(res); // { status, response: {...}, code }
};

export const deleteCareerAdviceAdmin = async (uuid) => {
    const token = await fetchToken();
    const res = await fetch(`${BASE_URL}/${ADMIN}/${CAREER_ADVICE_ADMIN}/${uuid}`, {
        method: "DELETE",
        headers: {
            Accept: "application/json",
            "Content-type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    });
    return parseJsonOrThrow(res); // { status, response: null|{}, code }
};